import { GcTooltip } from '@garmin/components-global';

export default {
  name: 'Tooltip',
  data() {
    return {
      className: 'app__tooltip',
      open: false,
    };
  },
  computed: {
    summaryClassName() {
      if (this.hasTooltipText) {
        return `${this.className}__summary ${this.className}__summary__active`;
      }
      return `${this.className}__summary`;
    },
    iconClassName() {
      return `${this.className}__icon`;
    },
    hasTooltipText() {
      return !!this.tooltipText.length;
    },
    showTooltipText() {
      return this.open && this.tooltipText.length;
    },
  },
  methods: {
    toggleTooltip() {
      this.open = !this.open;
    },
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
      default: '',
    },
  },
  components: {
    GcTooltip,
  },
};
